import type { LoadingConfig } from '@nw/shared/ui';

import { NIATLoader } from '../Common/components/NIATLoader';

export const APP_CONTEXTUAL_LOADING_CONFIG: LoadingConfig = {
  variant: 'contextual',
  interval: 6000,
  textAnimation: 'fade-in-out',
  loadingLogo: NIATLoader as any
};
export const SECTIONS_CONTEXTUAL_LOADING_CONFIG: LoadingConfig = {
  variant: 'contextual',
  texts: [
    'NIAT student built NeuroNexus AI for coma analysis',
    'NIAT student Pooja built a smart farming drone',
    '2nd-year NIAT student Sachin pitched his AI startup to investors',
    '200+ NIAT students landed internships with stipend',
    '2nd-year NIAT student, Sachin’s startup idea can disrupt a $352B industry',
    'Sharvan Gajula, an NIAT student, won ₹1.5 lakh at a global hackathon',
    "Vishwaksena, an NIAT student, launched a startup that's generating revenue",
    'Pranay, a shy guy, is now a content creator with 6L+ views on YouTube'
  ],
  interval: 6000,
  textAnimation: 'fade-in-out',
  loadingLogo: NIATLoader as any
};
export const NAT_TEST_RESULTS_CONTEXTUAL_LOADING_CONFIG: LoadingConfig = {
  variant: 'contextual',
  texts: ['Mapping your skills to real-world careers…'],
  interval: 6000,
  textAnimation: 'fade-in-out',
  loadingLogo: NIATLoader as any
};
